<script lang="ts">
import { defineComponent } from 'vue'
import PageBreadcrumb from '@/components/common/PageBreadcrumb.vue'
import DocumentsTable from '../components/DocumentsTable.vue'

export default defineComponent({
  name: 'documents-list',
  data() {
    return {
      id: 'all',
    }
  },
  components: { DocumentsTable, PageBreadcrumb },
})
</script>

<template>
  <main class="flex-1">
    <div class="py-6">
      <div class="max-w-(--breakpoint-2xl) mx-auto">
        <PageBreadcrumb page-title="Zoznam dokladov" />
      </div>
      <documents-table :hladaj="id"></documents-table>
    </div>
  </main>
</template>
